var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLookUpUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLookUpUser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.3358349,12.4578251 L11.2442713,9.454325 C11.227841,9.43836245 11.2085681,9.42720523 11.1913988,9.41234736 C11.7997169,8.51584859 12.1547586,7.44271234 12.1547586,6.28865866 C12.1547586,3.14933882 9.53529535,0.604444444 6.30404598,0.604444444 C3.07279661,0.604444444 0.453333333,3.14933882 0.453333333,6.28860343 C0.453333333,9.4278128 3.07273976,11.9727624 6.30398913,11.9727624 C7.49191501,11.9727624 8.59643878,11.6278277 9.51920619,11.0368268 C9.53449942,11.0534521 9.5459267,11.0721764 9.56235698,11.0881389 L12.6539774,14.0917495 C13.1184027,14.5428986 13.8713527,14.5428986 14.3358349,14.0917495 C14.8002033,13.6405451 14.8002033,12.9090295 14.3358349,12.4578251 Z M6.30404598,10.0022437 C4.19289787,10.0022437 2.48153414,8.33959774 2.48153414,6.28860343 C2.48153414,4.23755388 4.19295472,2.57490797 6.30404598,2.57490797 C8.41508039,2.57490797 10.126501,4.23760912 10.126501,6.28860343 C10.126501,8.33959774 8.41508039,10.0022437 6.30404598,10.0022437 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Copy-2",
    transform: "translate(-34.000000, -233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SearchField",
    transform: "translate(18.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLookUpUser",
    transform: "translate(15.880000, 10.840000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/BlueGray"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D4D7DC",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.880000, -8.840000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 34 0 34 34 0 34"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLookUpUser);
export default __webpack_public_path__ + "static/media/icLookUpUser.aacc1c47a12935abcf1666a597553c44.svg";
export { ForwardRef as ReactComponent };